import React, { FC } from "react";
import { ApplePayPaymentContainer } from "./index.styled";

interface ApplePayButtonProps {
  onClick?: () => void;
}

export const ApplePayButton: FC<ApplePayButtonProps> = ({ onClick }) => {
  return (
    <ApplePayPaymentContainer
      data-testid="apple-pay-button"
      type="button"
      onClick={onClick}
    />
  );
};
